import axios from "../../axiosInstance";

const job_base_api = "/im/ob/import";
class JobServices{
    getTransitType(details){
        return axios.post(job_base_api+'/getTransitType',details);
    }
    getCustomHouseCodeBasedOnTransitType(details){
        return axios.post(job_base_api+'/getCustomHouseCodeBasedOnTransitType',details);
    }
    getRegionalName(details){
        return axios.post(job_base_api+'/getRegionalName',details);
    }
    getImporterBranch(details){
        return axios.post(job_base_api+'/getImporterBranch',details)
    }
    getImporter(details){
        return axios.post(job_base_api+'/getImporter',details)
    }
    getAdCode(details){
        return axios.post(job_base_api+'/getAdCode',details)
    }
    getCountryName(details){
        return axios.post(job_base_api+'/getCountryName',details);
    }
    insertPreAlertJobNo(details){
        return axios.post(job_base_api+'/insertPreAlertJobNo',details);
    }
    getCertificateType(){
        return axios.get(job_base_api+'/getCertificateType');
    }
    getCertificateDetails(details){
        return axios.post(job_base_api+'/getCertificateDetails',details)
    }
    insertCertificateDetails(details){
        return axios.post(job_base_api+'/insertCertificateDetails',details)
    }
    updateCertificateDetails(details){
        return axios.put(job_base_api+'/updateCertificateDetails',details)
    }
    deleteCertificateDetails(ConsignmentId,CertificateId){
        return axios.delete(job_base_api+'/deleteCertificateDetails?ConsignmentId='+ConsignmentId+'&CertificateId='+CertificateId)
    }
    getbondCode(){
        return axios.get(job_base_api+'/getbondCode');
    }
    getBondDetails(details){
        return axios.post(job_base_api+'/getBondDetails',details);
    }
    getCustomHouseCode(details){
        return axios.post(job_base_api+'/getCustomHouseCode',details);
    }
    insertBondDetails(details){
        return axios.post(job_base_api+'/insertBondDetails',details);
    }
    updateBondDetails(details){
        return axios.put(job_base_api+'/updateBondDetails',details);
    }
    deleteBondDetails(ConsignmentId,BondNo){
        return axios.delete(job_base_api+'/deleteBondDetails?ConsignmentId='+ConsignmentId+"&BondNo="+BondNo);
    }
    getPortLocationBasedCountryTransitType(details){
        return axios.post(job_base_api+'/getPortLocationBasedCountryTransitType',details);
    }
    getContainer(details){
        return axios.post(job_base_api+'/getContainer',details);
    }
    insertContainer(details){
        return axios.post(job_base_api+'/insertContainer',details);
    }
    updateContainer(details){
        return axios.put(job_base_api+'/updateContainer',details);
    }
    deleteContainer(ContainerId){
        return axios.delete(job_base_api+'/deleteContainer?ContainerId='+ContainerId);
    }
    getWarehouseDetails(details){
        return axios.post(job_base_api+'/getWarehouseDetails',details);
    }
    updateWarehouseDetails(details){
        return axios.put(job_base_api+'/updateWarehouseDetails',details);
    }
    getUOM(details){
        return axios.post(job_base_api+'/getUOM',details);
    }
    getHSSDetails(consignmentId){
        return axios.get(job_base_api+'/getHSSDetails?consignmentId='+consignmentId)
    }
    insertHSSDetails(details){
        return axios.post(job_base_api+'/insertHSSDetails',details)
    }
    updateHSSDetails(details){
        return axios.put(job_base_api+'/updateHSSDetails',details)
    }
    deleteHSSDetails(ConsignmentId,IECcodeHss){
        return axios.delete(job_base_api+'/deleteHSSDetails?ConsignmentId='+ConsignmentId+'&IECcodeHss='+IECcodeHss)
    }
    getPermission(ConsignmentId,permissionCode){
        return axios.get(job_base_api+'/getPermission?consignmentId='+ConsignmentId+'&permissionCode='+permissionCode)
    }
    insertPermission(details){
        return axios.post(job_base_api+'/insertPermission',details)
    }
    updatePermission(details){
        return axios.put(job_base_api+'/updatePermission',details)
    }
    deletePermission(PermissionId){
        return axios.delete(job_base_api+'/deletePermission?PermissionId='+PermissionId)
    }
    getGstinType(){
        return axios.get(job_base_api+'/getGstinType');
    }
    getCommercialTax(consignmentId){
        return axios.get(job_base_api+'/getCommercialTax?consignmentId='+consignmentId);
    }
    insertCommercialTax(details){
        return axios.post(job_base_api+'/insertCommercialTax',details);
    }
    updateCommercialTax(details){
        return axios.put(job_base_api+'/updateCommercialTax',details);
    }
    deleteCommercialTax(ConsignmentId,CommercialTax){
        return axios.delete(job_base_api+'/deleteCommercialTax?ConsignmentId='+ConsignmentId+"&CommercialTax="+CommercialTax);
    }
    
    getCTXTypeAssign(details){
        return axios.post(job_base_api+'/getCTXTypeAssign',details);
    }
    
    insertEdiJob(details){
        return axios.post(job_base_api+'/insertEdiJob',details);
    }
    updateEdiJob(details){
        return axios.put(job_base_api+'/updateEdiJob',details);
    }
    deleteConsignment(ConsignmentId){
        return axios.delete(job_base_api+'/deleteConsignment?ConsignmentId='+ConsignmentId);
    }
    getConsignmentJobEntry(details){
        return axios.post(job_base_api+'/getConsignmentJobEntry',details);
    }
    getIgmBasedOnContainer(job){
        return axios.get(job_base_api+'/getIgmBasedOnContainer?consignmentId='+job);
    }
    getIGM_Details(details){
        return axios.post(job_base_api+"/getIGM_Details",details);
    }
    insertIGMDetails(details){
        return axios.post(job_base_api+'/insertIGMDetails',details);
    }
    updateIGMDetails(IGMId,details){
        return axios.put(job_base_api+'/updateIGMDetails?IGMId='+IGMId,details);
    }
    deleteIGMDetails(IGMId){
        return axios.delete(job_base_api+'/deleteIGMDetails?IgmId='+IGMId);
    }
    getPortLocationBasedTransitType(details){
        return axios.post(job_base_api+'/getPortLocationBasedTransitType',details);
    }
    getBeResponse(){
        return axios.get(job_base_api+'/getBeResponse')
    }
    getBeDetails(details){
        return axios.post(job_base_api+'/getBeDetails',details);
    }
    updateBeUpdation(details){
        return axios.put(job_base_api+'/updateBeUpdation',details)
    }

    updateBeAmendmentStatus(details){
        return axios.put(job_base_api+'/updateBeAmendmentStatus',details)
    }

}

export default new JobServices();